import { ChangeDetectorRef, Component, Renderer2, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { AbstractComponent } from "./abstract/abstract.component";
import { HeaderComponent } from "./incs/header.component";


@Component({
    selector: "[kilowant-login]",
    templateUrl: "../../html/main-about.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent]
})
export class AboutComponent extends AbstractComponent {

    constructor(
        router: Router,
        route: ActivatedRoute,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService
    ) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
    }

    ngOnInit(): void {
    }
}
